import React, { useEffect, useRef, useState } from "react";
import "./user.style.scss";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";
import { Calendar } from "react-modern-calendar-datepicker";
import useOnBlur from "../../../util/useOnBlue";
import { Button, Card, Input, Select, Switch } from "antd";
import { get, post, responseValidator } from "../../../api";
import { toast } from "react-toastify";
import Loading from "../../../loading/loading.index";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function CEUser() {
  const { Option } = Select;
  const [roles, setRoles] = useState([]);
  const [rolesSelected, setRolesSelected] = useState([]);

  const [isCalender, setIsCalender] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const isCalenderRef = useRef();
  const [birthInputShow, setBirthInputShow] = useState();
  const [birthDate, setBirthDate] = useState(null);
  const persian = /^[\u0600-\u06FF\s]+$/;

  const [nationalCode, setNationalCode] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [landline, setLandline] = useState(null);

  const [password, setPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitloading, setSubmitLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState(null);
  const [isActive, setIsActive] = useState(null);

  const [selfiStatus, setSelfiStatus] = useState(false);
  const [videoStatus, setVideoStatus] = useState(false);
  const [nationalCodeStatus, setNationalCodeStatus] = useState(false);


  useEffect(() => {
    new Promise(resolve => {
      if (window.location.pathname.split("/").length > 4) {
        setLoading(true);
        setIsEdit(true);
        setId(window.location.pathname.split("/")[4]);
        get(`/User/GetAllUser/${window.location.pathname.split("/")[4]}`).then(
          res => {
            setLoading(false);
            resolve();
            if (responseValidator(res.status)) {
              console.log(res.data.data);
              if (res.data.data.phoneNumber)
                setPhoneNumber(res.data.data.phoneNumber);
              if (res.data.data.email)
                setEmail(res.data.data.email.toLowerCase());
              if (res.data.data.roles)
                setRolesSelected(res.data.data.roles);
              if (res.data.data.isActive)
                setIsActive(res.data.data.isActive);
              if (res.data.data.firstName)
                setFirstName(res.data.data.firstName);
              if (res.data.data.lastName)
                setLastName(res.data.data.lastName);
              if (res.data.data.nationalCode)
                setNationalCode(res.data.data.nationalCode);
              if (res.data.data.birthDate)
                setBirthInputShow(
                  new Date(
                    res.data.data.birthDate
                  ).toLocaleDateString("fa-IR")
                );
              setBirthDate(res.data.data.birthDate);
              if (res.data.data.landline)
                setLandline(res.data.data.landline);
              if (res.data.data.selfiStatus)
                setSelfiStatus(res.data.data.selfiStatus);
              if (res.data.data.videoStatus)
                setVideoStatus(res.data.data.videoStatus);
              if (res.data.data.nationalCodeStatus)
                setNationalCodeStatus(res.data.data.nationalCodeStatus);

            }
          }
        );
      } else resolve();
    }).then(() => {
      get("/User/GetAllRoles").then(res => {
        setLoading(false);
        if (responseValidator(res.status)) {
          const children = [];
          res.data.data.map((item, index) => {
            children.push(<Option key={item}>{item}</Option>);
          });
          setRoles(children);
        }
      });
    });
  }, []);
  // 0:not open , 1:open , 2:closed
  function datePickerHandler(e) {
    setSelectedDay(e);
    console.log(e);
    setBirthInputShow(e.year + "/" + e.month + "/" + e.day)


    const JalaliDate = {
      g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
    };

    JalaliDate.jalaliToGregorian = function (j_y, j_m, j_d) {
      j_y = parseInt(j_y);
      j_m = parseInt(j_m);
      j_d = parseInt(j_d);
      var jy = j_y - 979;
      var jm = j_m - 1;
      var jd = j_d - 1;

      var j_day_no = 365 * jy + parseInt(jy / 33) * 8 + parseInt((jy % 33 + 3) / 4);
      for (var i = 0; i < jm; ++i) j_day_no += JalaliDate.j_days_in_month[i];

      j_day_no += jd;

      var g_day_no = j_day_no + 79;

      var gy = 1600 + 400 * parseInt(g_day_no / 146097); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
      g_day_no = g_day_no % 146097;

      var leap = true;
      if (g_day_no >= 36525) /* 36525 = 365*100 + 100/4 */ {
        g_day_no--;
        gy += 100 * parseInt(g_day_no / 36524); /* 36524 = 365*100 + 100/4 - 100/100 */
        g_day_no = g_day_no % 36524;

        if (g_day_no >= 365) g_day_no++;
        else leap = false;
      }

      gy += 4 * parseInt(g_day_no / 1461); /* 1461 = 365*4 + 4/4 */
      g_day_no %= 1461;

      if (g_day_no >= 366) {
        leap = false;

        g_day_no--;
        gy += parseInt(g_day_no / 365);
        g_day_no = g_day_no % 365;
      }

      for (var i = 0; g_day_no >= JalaliDate.g_days_in_month[i] + (i == 1 && leap); i++)
        g_day_no -= JalaliDate.g_days_in_month[i] + (i == 1 && leap);
      var gm = i + 1;
      var gd = g_day_no + 1;

      gm = gm < 10 ? "0" + gm : gm;
      gd = gd < 10 ? "0" + gd : gd;

      return [gy, gm, gd];
    }

    let jD = JalaliDate.jalaliToGregorian(e.year, e.month, e.day),
      jResult = jD[0] + "/" + jD[1] + "/" + jD[2]
    // let date = moment
    console.log(jResult);
    // from(e.year + "/" + e.month + "/" + e.day, "en", "YYYY/MM/DD").format("YYYY/MM/DD")
    //console.log(date);
    // date = new Date(date);
    // console.log(date);
    // date = date.toISOString();
    //console.log(date);
    setBirthDate(jResult);
    setIsCalender(false);
  }

  useOnBlur(isCalenderRef, () => {
    if (isCalender) setIsCalender(false);
  });

  function submitHandler() {
    setSubmitLoading(true);
    if (!isEdit) {
      const body = {
        phoneNumber,
        email,
        password,
        roles: rolesSelected
      };

      post("/User/Create", body).then(res => {
        setSubmitLoading(false);
        if (responseValidator(res.status)) {
          toast.success(res.data.message);
          setTimeout(
            () => window.location.replace("/adminpanel/usermanagement"),
            2000
          );
        } else toast.error(res.data.message);
      });
    } else {
      const body = {
        id: id,
        phoneNumber,
        roles: rolesSelected,
        email: '',
        isActive,
        landline,
        nationalCode,
        firstName,
        lastName,
        selfiStatus,
        videoStatus,
        nationalCodeStatus,
        birthDate,
      };
      if (password) {
        body.password = password
      }
      if (email) {
        body.email = email
      }
      post("/User/Update", body).then(res => {
        setSubmitLoading(false);
        if (responseValidator(res.status)) {
          toast.success(res.data.message);
          setTimeout(
            () => window.location.replace("/adminpanel/usermanagement"),
            2000
          );
        } else toast.error(res.data.message);
      });
    }
  }

  return (
    <div className="temx-user-management-user">
      {loading && <Loading />}
      <Card style={{ paddingLeft: "-38px" }} title="اطلاعات کاربر">
        <div className="my-row">
          <div className="items">
            <label>ایمیل*</label>
            <Input
              value={email}
              onChange={e => setEmail(e.target.value)}
              type="email"
              placeholder="ایمیل کاربر را وارد کنید"
            />
          </div>
          <div className="items">
            <label>شماره تماس*</label>
            <Input
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              type="number"
              placeholder="شماره تماس کاربر را وارد کنید"
              autoComplete="off"
            />
          </div>
        </div>
        <div className="my-row">

          <div className="items">
            <label>رمز عبور*</label>
            <Input
              onChange={e => setPassword(e.target.value)}
              type="password"
              autoComplete="new-password"
              placeholder="رمز عبور کاربر را وارد کنید"
            />
          </div>
          <div className="items">
            <label>نقش ها*</label>
            <Select
              value={rolesSelected}
              mode="tags"
              style={{ width: "100%" }}
              placeholder="نقش های کاربر را وارد کنید"
              onChange={e => setRolesSelected(e)}
            >
              {roles}
            </Select>
          </div>
        </div>
        <div className="my-row">
          <div className="items">
            <label>نام</label>
            <Input
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
              type="text"
              placeholder="نام کاربر را وارد کنید"
            />
          </div>
          <div className="items">
            <label>نام خانوادگی</label>
            <Input
              value={lastName}
              type="text"
              placeholder="نام خانوادگی کاربر را وارد کنید"
              onChange={e => setLastName(e.target.value)}
            />
          </div>
        </div>
        <div className="my-row">

          <div className="items">
            <label>کدملی</label>
            <Input
              value={nationalCode}
              onChange={e => setNationalCode(e.target.value)}
              type="text"
              placeholder="کدملی کاربر را وارد کنید"
            />
          </div>
          <div className="items">

            <label>تاریخ تولد</label>

            <div className="birth">
              <Input
                onClick={() => setIsCalender(true)}
                value={birthInputShow}
                placeholder="تاریخ تولد"
              />
              <i
                onClick={() => setIsCalender(!isCalender)}
                className="icon icon-calendar"
              />
              <div
                ref={isCalenderRef}
                className={`my-calender ${isCalender ? "active" : ""
                  }`}
              >
                <Calendar
                  colorPrimary={"#157DE1"}
                  value={selectedDay}
                  locale="fa"
                  onChange={datePickerHandler}
                  shouldHighlightWeekends
                />
              </div>
            </div>
          </div>
        </div>
        <div className="my-row">

          <div className="items">
            <label>شماره تلفن ثابت</label>
            <Input
              value={landline}
              onChange={e => setLandline(e.target.value)}
              type="text"
              placeholder="شماره تلفن ثابت کاربر را وارد کنید"
            />
          </div>
          <div className="items"></div>
        </div>

        <div className="my-row">
          <div className="items">
            {isEdit && (
              <div className="active-status">
                <label>وضعیت (فعال یا غیر فعال بودن)</label>
                <Switch checked={isActive} onClick={e => setIsActive(e)} />
              </div>
            )}
          </div>

        </div>
        <div className="my-btn">



          <span />
          <Button
            className="my-real-btn"
            disabled={
              (!isEdit && !password) ||
              rolesSelected.length === 0
            }
            onClick={submitHandler}
            type={"primary"}
            loading={submitloading}
          >
            {!isEdit ? (
              "ساخت حساب جدید"
            ) : (
              "ویرایش حساب"
            )}
          </Button>
        </div>
      </Card>
    </div>
  );
}
